import { reactive } from 'vue';

export const criarEvento = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idoperador: 0,
        idequipamento: 0,
        idos: 0,
        idossegmento: 0,
        idossmall: 0,
        idanexo: 0,
        idanexo2: 0,
        tpevento: '',
        xtpevento: '',
        dtevento: '',
        hrevento: '',
        observacoes: '',
        latitude: 0,
        longitude: 0,
        horaskm: 0,
        ttentregas: 0,
        concluidoparcial: 'N',
        manual: 0,
        idusuario: 0
    });
};